module.exports = __webpack_public_path__ + "static/img_2175-0ce640bef2444eb44be24f08dca4f611.webp";